import * as Yup from 'yup';

type SpotifyLinkRequestDto = {
    type: 'spotify';
    link: string;
};

type SpotifyLinkResponseDto = {
    type: 'spotify';
    data: SpotifyTrackInfo;
};

export type LinksRequestDto = SpotifyLinkRequestDto;

// deno-lint-ignore no-namespace
export namespace LinksRequestDto {
    export const LinkRegex = /^https:\/\/open\.spotify\.com\/track\/[a-zA-Z0-9]/;

    export function createRequestValidation(): Yup.ObjectSchema<LinksRequestDto> {
        return Yup.object({
            type: Yup.string<LinksRequestDto['type']>()
                .required('Type is required')
                .oneOf(['spotify'], 'Invalid type'),
            link: Yup.string()
                .required('Link is required')
                .matches(LinkRegex, 'Invalid spotify track link'),
        }).noUnknown();
    }
}


export type LinksResponseDto = SpotifyLinkResponseDto;

type ColorDef = { hex: string };
type SourceDef = { url: string, width: number, height: number };
type SourceDefNew = { url: string, maxWidth: number, maxHeight: number };

export type SpotifyTrackInfo = {
    type: string,
    name: string;
    uri: string;
    id: string;
    title: string;

    /** @deprecated not available any more */
    coverArt: {
        /** @deprecated */
        extractedColors?: { colorDark: ColorDef, colorLight: ColorDef },
        sources: SourceDef[],
    },
    artists: {
        name: string;
    }[];

    releaseDate: { isoString: string },

    visualIdentity: {
        image: SourceDefNew[],
    }

    // the following are known and parsed but removed from the response since not used

    /** @deprecated */
    duration?: number,
    /** @deprecated */
    maxDuration?: number,
    /** @deprecated */
    isPlayable?: boolean,
    /** @deprecated */
    isExplicit?: boolean,
    /** @deprecated */
    audioPreview?: {
        url: string,
        format: string,
    },
    /** @deprecated */
    hasVideo?: boolean,
    /** @deprecated */
    relatedEntityUri?: string,
};

export namespace SpotifyTrackInfo {
    export function cleanup(info: SpotifyTrackInfo | null) {
        if (!info) {
            return;
        }

        if (info.coverArt) {
            delete info.coverArt.extractedColors;

            if (info.coverArt.sources?.length > 1) {
                // get the highest resolution
                info.coverArt.sources.sort((a, b) => b.width - a.width);
                // remove all others
                info.coverArt.sources.splice(1);
            }
        }

        if (info.visualIdentity) {

            if (info.visualIdentity.image?.length > 1) {
                // get the highest resolution
                info.visualIdentity.image.sort((a, b) => b.maxWidth - a.maxWidth);
                // remove all others
                info.visualIdentity.image.splice(1);
            }
        }

        delete info.duration;
        delete info.maxDuration;
        delete info.isPlayable;
        delete info.isExplicit;
        delete info.audioPreview;
        delete info.hasVideo;
        delete info.relatedEntityUri;
    }
}
